import MainLoader from "@/components/Reusable/Loaders/MainLoader";

const LoadingSearch = ({ locale }) => {
  return (
    <div className="loader-container min-h-[70vh] flex flex-col justify-center items-center">
      <h4 className="mx-auto w-full flex justify-center mb-[1.5rem] text-[1.5rem] font-[600]">
        {locale === "ar" ? "جار البحث" : "Loading..."}
      </h4>
      <MainLoader spinnerColor="#D9232E" />
    </div>
  );
};

export default LoadingSearch;
